import { Pipe, PipeTransform } from '@angular/core';
import { BillingEquipment } from '~core/models/sales-point.models';

@Pipe({
  name: 'billingEquipment',
  pure: true,
  standalone: true
})
export class BillingEquipmentPipe implements PipeTransform {
  private readonly _map: Record<BillingEquipment, string> = {
    [BillingEquipment.fnePlatform]: 'Plateforme FNE',
    [BillingEquipment.termeFne]: 'Terminal FNE',
    [BillingEquipment.appsMobileRne]: 'Application Mobile RNE',
    [BillingEquipment.apiFne]: 'API FNE'
  };

  transform(value: BillingEquipment | undefined): string {
    if (!value) return 'Inconnu';
    return this._map[value] || value;
  }
}
